import React, { useState } from 'react';
import { Modal, Form, Input, Select, Button, message } from 'antd';
import { competitorAPI } from '../../../../../../../services/api';
import dayjs from 'dayjs';

const { Option } = Select;

interface AddCompetitorModalProps {
    skuId: number;
    visible: boolean;
    onClose: () => void;
    onSuccess: () => void;
}

export const AddCompetitorModal: React.FC<AddCompetitorModalProps> = ({
    skuId,
    visible,
    onClose,
    onSuccess,
}) => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);

    const handleAdd = async (values: any) => {
        setSubmitting(true);
        try {
            await competitorAPI.create({
                ...values,
                sku: skuId,
                first_seen: dayjs().format('YYYY-MM-DD'),
                last_seen: dayjs().format('YYYY-MM-DD'),
            });
            message.success('竞品添加成功，正在后台抓取详情...');
            onClose();
            form.resetFields();
            onSuccess();
        } catch (error: any) {
            message.error(error.userMessage || '添加失败');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            title="添加竞品"
            open={visible}
            onCancel={onClose}
            footer={null}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleAdd}
                initialValues={{ threat_level: 'medium' }}
            >
                <Form.Item
                    name="asin"
                    label="ASIN"
                    rules={[{ required: true, message: '请输入ASIN' }]}
                >
                    <Input placeholder="输入竞品ASIN" />
                </Form.Item>

                <Form.Item
                    name="threat_level"
                    label="威胁等级"
                >
                    <Select>
                        <Option value="low">低</Option>
                        <Option value="medium">中</Option>
                        <Option value="high">高</Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    name="notes"
                    label="备注"
                >
                    <Input.TextArea rows={2} />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={submitting} block>
                        添加并抓取
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};
